module.exports = __webpack_public_path__ + "@/assets/img/maestro.2da77075.svg";